<template>
    <form class="row g-3" id="cat_add" @submit="submitForm($event)" method="post" :action="action">
        <input type="hidden" name="_token" :value="csrf">
        <div class="col-md-12">
            <label for="cat_name" class="form-label">Название категории</label>
            <input type="text" v-model="data.title" class="form-control" id="cat_name" required>
        </div>
        <div class="col-md-12">
            <label class="form-label">Родительская категория</label>
            <!-- <select id="cat_parent" v-model="data.parent" class="form-select">
                 <option selected value="0">Без родительской</option>
             </select>-->
            <model-select :options="cat_list"
                          v-model="data.parent"
                          placeholder="Выбрать..."></model-select>
        </div>
        <div class="col-md-12">
            <label for="cat_position" class="form-label">Позиция</label>
            <input type="number" class="form-control" id="cat_position" value="0" v-model="data.position">
        </div>
        <div class="col-md-12">
            <div class="option_block">
                <h3>Базовые поля для заполнения</h3>
                <button type="button" class="btn btn-dark" @click="addInput">Добавить</button>
                <div id="option_input_list" class="mt-3">
                    <div class="d-flex align-items-baseline" v-for="(value, id) in data.options">
                        <input type="text" name="options[]" v-model="data.options[id]" class="form-control mb-3"/>
                        <button type="button" @click="deleteInput(id)" class="btn btn-danger">Удалить</button>
                    </div>
                </div>
            </div>
        </div>


        <div class="col-md-4  d-flex align-items-end">
            <div class="form-check form-switch">
                <input class="form-check-input" v-model="data.enabled" value="1" checked type="checkbox" role="switch"
                       id="cat_active">
                <label class="form-check-label" for="cat_active">Активна</label>
            </div>

        </div>

        <div class="col-12">
            <button type="submit" class="btn btn-success">Сохранить</button>
        </div>
    </form>
</template>

<script>
    import {ModelSelect} from 'vue-search-select'

    export default {
        components: {
            ModelSelect
        },
        data() {
            return {
                data: {
                    title: '',
                    parent: '',
                    position: '',
                    enabled: true,
                    options: []
                },
                cat_list: [
                    {
                        text: 'Без родительской',
                        value: 0,
                        selected: true
                    }
                ]
            }
        },
        props: ['action', 'cat'],
        computed: {
            csrf() {
                return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            },
        },
        methods: {
            addInput: function () {
                this.data.options.push('');
            },
            deleteInput: function (id) {
                this.data.options.splice(id, 1);
            },
            submitForm: function ($event) {
                const vm = this;
                $event.preventDefault();

                axios.post(this.action, {
                    data: this.data,
                    _method: 'patch'
                }).then(function (response) {
                    let $data = response.data;
                    if ($data.status === 'success') {
                        vm.$swal({
                            icon: 'success',
                            title: 'Готово!',
                            text: 'Успешно сохранили'
                        });
                    }
                }).catch(function (error) {
                    let $response = error.response;
                    vm.$swal({
                        icon: 'error',
                        title: 'Ошибка!',
                        text: $response.data.message
                    });
                })
                return false;
            },
            async getAllCat() {
                const vm = this;
                let cat_list;
                return axios.get('/admin/cats/get-all-cat');
            }
        },
        mounted() {
            const vm = this;
            this.getAllCat().then(function (response) {
                vm.cat_list = response.data;
            })
            this.cat.options = JSON.parse(this.cat.options);
            this.data = this.cat;

        }
    }
</script>
